module.exports = __webpack_public_path__ + "images/emoji/vertical_traffic_light.b3cb87daf6cbf7b35936.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/vertical_traffic_light.png
// module id = ceU9
// module chunks = 24